import React from 'react';
import MemberSpecial from './MemberSpecial';

const Members = (props: any) => <MemberSpecial {...props} />;

export default Members;
